import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class DonorsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              donors: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/project/donors', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.setState({donors: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openDonor(id) {
        this.props.navigate("donor", {caller: "donors", callargs: this.state.args, donor: id})
    }

    renderDonor(donor) {
        return (
            <tr
                id = {donor.id}
                className="table-row-clickable"
                onClick={()=>this.openDonor(donor.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {donor.name}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {donor.description}
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Источники финансирования"}/>
                 <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openDonor("")}
                        >
                            Добавить источник финансирования
                        </button>
                    </div>
                 </div>
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Наименование
                                        </th>
                                        <th id="descriptionCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Описание
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.donors.map((value, index) => this.renderDonor(value))}
                                </tbody>
                            </table>      
                        </div>
                    </div>
                </div>        
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/donors.js